import { c as _c } from "react/compiler-runtime";
import { clsx } from 'clsx';
import styles from './Box.module.css';
import type { BoxProps, SpacingUnits } from './Box.types';
const Box = t0 => {
  const $ = _c(31);
  const {
    children,
    space,
    spaceHorizontal,
    spaceVertical,
    spaceTop,
    spaceRight,
    spaceBottom,
    spaceLeft,
    mdSpace,
    mdSpaceHorizontal,
    mdSpaceVertical,
    mdSpaceTop,
    mdSpaceRight,
    mdSpaceBottom,
    mdSpaceLeft,
    isCentered,
    isContainer,
    isFlex,
    fullHeight
  } = t0;
  let boxVars;
  if ($[0] !== mdSpace || $[1] !== mdSpaceBottom || $[2] !== mdSpaceHorizontal || $[3] !== mdSpaceLeft || $[4] !== mdSpaceRight || $[5] !== mdSpaceTop || $[6] !== mdSpaceVertical || $[7] !== space || $[8] !== spaceBottom || $[9] !== spaceHorizontal || $[10] !== spaceLeft || $[11] !== spaceRight || $[12] !== spaceTop || $[13] !== spaceVertical) {
    const spacingUnits = {
      space,
      spaceHorizontal,
      spaceVertical,
      spaceTop,
      spaceRight,
      spaceBottom,
      spaceLeft,
      mdSpace,
      mdSpaceHorizontal,
      mdSpaceVertical,
      mdSpaceTop,
      mdSpaceRight,
      mdSpaceBottom,
      mdSpaceLeft
    };
    boxVars = {};
    for (const key in spacingUnits) {
      const unit = spacingUnits[key as keyof SpacingUnits];
      if (unit) {
        boxVars[`--box-${key}`] = `var(${unit})`;
      }
    }
    $[0] = mdSpace;
    $[1] = mdSpaceBottom;
    $[2] = mdSpaceHorizontal;
    $[3] = mdSpaceLeft;
    $[4] = mdSpaceRight;
    $[5] = mdSpaceTop;
    $[6] = mdSpaceVertical;
    $[7] = space;
    $[8] = spaceBottom;
    $[9] = spaceHorizontal;
    $[10] = spaceLeft;
    $[11] = spaceRight;
    $[12] = spaceTop;
    $[13] = spaceVertical;
    $[14] = boxVars;
  } else {
    boxVars = $[14];
  }
  const t1 = space || mdSpace;
  const t2 = spaceHorizontal || mdSpaceHorizontal;
  const t3 = spaceVertical || mdSpaceVertical;
  const t4 = spaceTop || mdSpaceTop;
  const t5 = spaceRight || mdSpaceRight;
  const t6 = spaceBottom || mdSpaceBottom;
  const t7 = spaceLeft || mdSpaceLeft;
  let t8;
  if ($[15] !== fullHeight || $[16] !== isCentered || $[17] !== isContainer || $[18] !== isFlex || $[19] !== t1 || $[20] !== t2 || $[21] !== t3 || $[22] !== t4 || $[23] !== t5 || $[24] !== t6 || $[25] !== t7) {
    t8 = clsx({
      [styles.centered]: isCentered,
      [styles.container]: isContainer,
      [styles.flex]: isFlex,
      [styles.padding]: t1,
      [styles.paddingHorizontal]: t2,
      [styles.paddingVertical]: t3,
      [styles.paddingTop]: t4,
      [styles.paddingRight]: t5,
      [styles.paddingBottom]: t6,
      [styles.paddingLeft]: t7,
      [styles.fullHeight]: fullHeight
    });
    $[15] = fullHeight;
    $[16] = isCentered;
    $[17] = isContainer;
    $[18] = isFlex;
    $[19] = t1;
    $[20] = t2;
    $[21] = t3;
    $[22] = t4;
    $[23] = t5;
    $[24] = t6;
    $[25] = t7;
    $[26] = t8;
  } else {
    t8 = $[26];
  }
  const boxClassNames = t8;
  let t9;
  if ($[27] !== boxClassNames || $[28] !== boxVars || $[29] !== children) {
    t9 = <div className={boxClassNames} style={boxVars} data-test-id="box">{children}</div>;
    $[27] = boxClassNames;
    $[28] = boxVars;
    $[29] = children;
    $[30] = t9;
  } else {
    t9 = $[30];
  }
  return t9;
};
export { Box };